/* Atyab Premium — page produit : galerie, variantes, colonne collante, quantité */
(function () {
  'use strict';

  /* ---------- Galerie ---------- */
  function initGallery(root) {
    var viewport = root.querySelector('[data-gallery-viewport]');
    if (!viewport) return;
    var slides = Array.prototype.slice.call(viewport.querySelectorAll('.at-gallery__slide'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-dot]'));
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if (slides.length < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
    }
    var current = 0;

    function setCurrent(index) {
      current = Math.max(0, Math.min(index, slides.length - 1));
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === current ? 'true' : 'false'); });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === current ? 'true' : 'false'); });
      if (prev) prev.disabled = current === 0;
      if (next) next.disabled = current === slides.length - 1;
    }

    function goTo(index, smooth) {
      var slide = slides[Math.max(0, Math.min(index, slides.length - 1))];
      if (!slide) return;
      viewport.scrollTo({ left: slide.offsetLeft - viewport.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setCurrent(index);
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { goTo(index); });
    });
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () { goTo(index); });
    });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    var ticking;
    viewport.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var center = viewport.scrollLeft + viewport.clientWidth / 2;
        var closest = 0;
        var min = Infinity;
        slides.forEach(function (slide, index) {
          var distance = Math.abs(slide.offsetLeft - viewport.offsetLeft + slide.clientWidth / 2 - center);
          if (distance < min) { min = distance; closest = index; }
        });
        setCurrent(closest);
        ticking = false;
      });
    }, { passive: true });

    root.addEventListener('atyab:gallery:select', function (event) {
      var id = String(event.detail.mediaId);
      var index = slides.findIndex(function (slide) { return slide.getAttribute('data-media-id') === id; });
      if (index > -1) goTo(index);
    });

    setCurrent(0);
  }

  /* ---------- Sélecteur de variantes ---------- */
  function initVariantPicker(section) {
    var picker = section.querySelector('[data-variant-picker]');
    if (!picker) return;
    var dataEl = section.querySelector('[data-variant-data]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (error) { return; }

    var productUrl = picker.getAttribute('data-product-url');
    var sectionId = picker.getAttribute('data-section-id');

    function selectedOptions() {
      return Array.prototype.map.call(
        picker.querySelectorAll('[data-option-index]'),
        function (group) {
          var checked = group.querySelector('input:checked');
          if (checked) return checked.value;
          var select = group.querySelector('select');
          return select ? select.value : null;
        }
      );
    }

    function matchVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) { return value === options[index]; });
      });
    }

    /* La barre d'achat collante (mobile) est rendue en dehors du conteneur
       [data-product-section] — c'est nécessaire pour son positionnement fixe.
       On cible donc toutes les zones [data-variant-swap] du document, sinon
       cette barre resterait figée sur le prix et la disponibilité de la
       variante précédente. */
    function swapTargets() {
      return Array.prototype.slice.call(document.querySelectorAll('[data-variant-swap]'));
    }

    function render(variant) {
      var url = productUrl + '?variant=' + variant.id + '&section_id=' + sectionId;
      var targets = swapTargets();
      targets.forEach(function (el) { el.setAttribute('aria-busy', 'true'); });
      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          targets.forEach(function (el) {
            var key = el.getAttribute('data-variant-swap');
            var incoming = doc.querySelector('[data-variant-swap="' + key + '"]');
            if (incoming) el.innerHTML = incoming.innerHTML;
            el.removeAttribute('aria-busy');
          });
          var idInput = section.querySelector('[data-variant-id]');
          if (idInput) idInput.value = variant.id;
          document.dispatchEvent(new CustomEvent('atyab:section:rendered'));
        })
        .catch(function () {
          targets.forEach(function (el) { el.removeAttribute('aria-busy'); });
        });
    }

    picker.addEventListener('change', function () {
      var variant = matchVariant(selectedOptions());
      if (!variant) return;
      if (window.history.replaceState) {
        var newUrl = new URL(window.location.href);
        newUrl.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', newUrl.toString());
      }
      var gallery = section.querySelector('[data-gallery]');
      if (gallery && variant.featured_media_id) {
        gallery.dispatchEvent(new CustomEvent('atyab:gallery:select', { detail: { mediaId: variant.featured_media_id } }));
      }
      render(variant);
    });
  }

  /* ---------- Colonne d'achat collante ----------
     La colonne d'achat est dimensionnée pour tenir dans la fenêtre : un simple
     position:sticky ancré sous l'en-tête suffit alors, et l'intégralité de la
     colonne — badges de réassurance compris — reste visible en permanence
     pendant qu'on fait défiler la description à gauche. C'est le cas normal, et
     il ne demande aucun JavaScript.

     Reste le cas limite : fenêtre courte, zoom navigateur, titre très long,
     réassurance chargée… Si la colonne devient plus haute que l'espace
     disponible, un ancrage en haut rendrait son bas définitivement
     inatteignable. On bascule alors l'ancrage vers le bas : la colonne défile
     normalement avec la page jusqu'à ce que son bas affleure le bas de la
     fenêtre, puis elle se fige — le bas de la colonne se découvre donc
     naturellement en descendant, sans barre de défilement interne et sans
     manipulation. Le sticky reste borné par sa zone de grille : il s'arrête
     de lui-même à la fin de la section produit et ne peut jamais recouvrir la
     section suivante ni le pied de page. */
  function initStickyBuybox(scope) {
    var column = (scope || document).querySelector('[data-sticky-column]');
    if (!column || !window.matchMedia) return;
    /* Un nouvel élément = nouveau marqueur : pas d'écouteurs empilés quand
       l'éditeur de thème re-rend la section. */
    if (column.getAttribute('data-sticky-bound')) return;
    column.setAttribute('data-sticky-bound', '1');

    var desktop = window.matchMedia('(min-width: 990px)');
    var pending = null;

    function apply() {
      pending = null;
      if (!desktop.matches) {
        column.style.removeProperty('--at-sticky-top');
        return;
      }
      var root = getComputedStyle(document.documentElement);
      var header = parseFloat(root.getPropertyValue('--at-header-h')) || 0;
      var gap = parseFloat(root.getPropertyValue('--at-space-5')) || 24;
      var top = header + gap;
      var overflow = column.offsetHeight - (window.innerHeight - top - gap);
      column.style.setProperty('--at-sticky-top', (overflow > 0 ? top - overflow : top) + 'px');
    }

    function schedule() {
      if (pending) return;
      pending = window.requestAnimationFrame(apply);
    }

    schedule();
    window.addEventListener('resize', schedule);
    document.addEventListener('atyab:section:rendered', schedule);
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(column);
    if (desktop.addEventListener) desktop.addEventListener('change', schedule);
    else if (desktop.addListener) desktop.addListener(schedule);
  }

  /* ---------- Quantité (hors panier) ---------- */
  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-product-qty-step]');
    if (!step) return;
    var wrap = step.closest('[data-product-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-product-qty-step'), 10);
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    if (next < min) next = min;
    input.value = next;
  });

  function init(scope) {
    (scope || document).querySelectorAll('[data-gallery]').forEach(initGallery);
    (scope || document).querySelectorAll('[data-product-section]').forEach(initVariantPicker);
    initStickyBuybox(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
